import { gql } from '@apollo/client';

export const GET_INDICATOR_PERIOD_DATES = gql`
  query GetIndicatorPeriodDates($input: IndicatorPeriodDatesInput!) {
    indicatorPeriodDates: getIndicatorPeriodDates(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          periodDate
          label
          periodNumber
        }
      }
    }
  }
`;
